export function mobilemenu() {

    // Give the current active submenu the active class
    let openMenus = document.querySelectorAll('.nav .current-page-ancestor > .nav');
    openMenus.forEach(element => {
        element.classList.add('open');
    });

    // Add event listeners to all the toggle buttons
    let submenuToggles = document.querySelectorAll('.nav .dropdown .dropdown-toggle');
    submenuToggles.forEach(toggle => {
        toggle.addEventListener('click', (event) => {
            event.currentTarget.parentNode.querySelector('.nav').classList.toggle('open');
        });
    });

    let mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    mobileMenuToggle.addEventListener('click', () => {
        document.querySelector('body').classList.toggle('menu-open');
    });

    let mobileMenuCloseButton = document.querySelector('.mobile-menu__close');
    let mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
    mobileMenuCloseButton.addEventListener('click', () => {
        document.querySelector('body').classList.toggle('menu-open');
    });
    mobileMenuOverlay.addEventListener('click', () => {
        document.querySelector('body').classList.toggle('menu-open');
    });
}